import angular from 'angular';
import modalMap from '../shared/components/modal-map/modal-map.view.html';
import modalConfirmation from '../shared/components/modal-response/modal-response.view.html';
import modalSelectModalidadPago from '../shared/components/modal-select-modalidad-pago/modal-select-modalidad-pago.view.html';

let inject = [
    '$scope',
    'SalesHomeService',
    '$state',
    '$rootScope',
    'SharedService',
    '$uibModal',
    '$timeout',
    'Pagination',
    'SessionService',
    '$window',
    '$filter',
    'CartService',
    '$mdToast',
    'DetailZoneService',
    'BillfoldService',
];

class SalesHomeController {
    constructor($scope, SalesHomeService, $state, $rootScope, SharedService, $uibModal, $timeout, Pagination, SessionService, $window,
        $filter, CartService, $mdToast, DetailZoneService, BillfoldService) {
        this.$state = $state;
        this.$scope = $scope;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.$uibModal = $uibModal;
        this.SalesHomeService = SalesHomeService;
        this.Pagination = Pagination;
        this.SharedService = SharedService;
        this.SessionService = SessionService;
        this.$window = $window;
        this.CartService = CartService;
        this.$mdToast = $mdToast;

        this.zoneService = DetailZoneService;
        this.billfoldService = BillfoldService;

        this.dashboard = {};
        this.dashboard.state = {};
        this.documentQuantitiesChart = {};
        this.lastItemsBought = {};

        this.dashboard.updatedAt = '';
        this.showDateRange = false;
        this.popup1 = false;

        this.dashboard.ordersTotalValue = 0;
        this.dashboard.quotesTotalValue = 0;
        this.dashboard.billsTotalValue = 0;

        this.dashboard.userMasterResume = {
            usuarios_creados: 0,
            usuarios_activos: 0,
            usuarios_inactivos: 0,
            usuarios_sin_inicio_sesion: 0,
            usuarios_supervisores: 0
        };

        this.dashboard.billfoldResume = {
            cupo_credito: 0,
            total_cartera: 0,
            cupo_disponible: 0,
            cartera_vencida: 0
        };

        this.debtsToPayResumen = {};
        this.dataComandResumen = {};


        this.dashboardFormData = {
            startDate: new Date(moment().subtract(1, 'month').format('YYYY-MM-DD')),
            endDate: new Date(moment().format('YYYY-MM-DD'))
        };

        this.orderResumeChart = {
            data: {
                "type": "ring",
                "legend": {
                    //   "highlight-plot":true,
                    "x": "80%",
                    "y": "0%"
                },
                "plotarea": {
                    // "margin-right":"20%"
                },
                "plot": {
                    "highlight-state": {
                        "background-color": "red #ffe6e6",
                        "border-width": 1,
                        "border-color": "red",
                        "line-style": "dotted"
                    },
                    "slice": "50%",
                    "value-box": {
                        "placement": "out",
                        "font-color": "black",
                        "font-size": 11,
                        "font-weight": "normal"
                    },
                    "animation": {
                        "effect": "2",
                        "speed": "300",
                        "method": "0",
                        "sequence": "1"
                    }
                },
                "series": [
                    { "values": [234], "text": "Enero" },
                    { "values": [121], "text": "Febrero" },
                    { "values": [77], "text": "Marzo" }
                ]
            }
        }
    }

    $onInit() {
        this.calendarWidget = this.shCtrl.ngAuthSettings.site.config.data.register.typeCalendarRegister;

        let dash = $('#dashboardForm #dashboardStartDate, #dashboardForm #dashboardEndDate');
        dash.on('changeDate', function (ev) {
            $(this).datepicker('hide');
        });

        /* Hide date picker on date selected */
        dash.datepicker().on('changeDate', function (e) {
            if (e.viewMode === 'days') {
                $(this).blur();
            }
        });

        /* Run search by default */
        this.$timeout(() => {
            $('#btnFilterDashboard').click()
        }, 5000);

        if(__env.adaptative){
            this.getDashboardInfoAdaptative();
        }
    }

    validateDate() {


    }

    getDashboardInfo(form) {
        this.dashboard.ordersTotalValue = 0;
        this.dashboard.quotesTotalValue = 0;
        this.dashboard.billsTotalValue = 0;

        this.dashboard.billfoldResume = {
            cupo_credito: 0,
            total_cartera: 0,
            cupo_disponible: 0,
            cartera_vencida: 0
        };

        let startDate = this.dashboardFormData.startDate;
        let endDate = this.dashboardFormData.endDate;
        let selectDate = +this.dashboardFormData.selectDate;

        startDate = moment(startDate).format('YYYY-MM-DD');
        endDate = moment(endDate).format('YYYY-MM-DD');


        if ((!this.showDateRange && !selectDate) ||
            (this.showDateRange && (!startDate || !endDate || (startDate > endDate)))
        ) {
            angular.forEach(form.$error.required, function (field) {
                field.$setDirty();
            });
        }
        else {
            if (!this.showDateRange) {
                // Current month
                if (selectDate === 999) {
                    startDate = moment().startOf('month').format('YYYY-MM-DD');
                }
                else {
                    startDate = moment().subtract(selectDate, 'months').format('YYYY-MM-DD');
                }

                endDate = moment().format('YYYY-MM-DD');
            }

            this.dashboard.state = {};
            this.dashboard.state.loading = false;

            this.getOrdersConsolidated(startDate, endDate);
            //this.getInfoBillfoldState();
            this.getLastItemsBought();
            this.getResumeMasterUser();
            this.getDebtsToPayClient();

            this.SessionService.getGlobals().then(globals => {
                this.shCtrl.globals = globals;

                if (this.shCtrl.globals.currentClient.seller.movil) {
                    this.sellerPhone = globals.currentClient.seller.movil;
                } else {
                    this.sellerPhone = globals.currentClient.seller.telefono;
                }

                console.log(this.shCtrl.globals);
            })
        }
    }

    getDashboardInfoAdaptative() {
        this.dashboard.ordersTotalValue = 0;
        this.dashboard.quotesTotalValue = 0;
        this.dashboard.billsTotalValue = 0;

        this.dashboard.billfoldResume = {
            cupo_credito: 0,
            total_cartera: 0,
            cupo_disponible: 0,
            cartera_vencida: 0
        };

        let startDate = this.dashboardFormData.startDate;
        let endDate = this.dashboardFormData.endDate;
        let selectDate = +this.dashboardFormData.selectDate;

        startDate = moment(startDate).format('YYYY-MM-DD');
        endDate = moment(endDate).format('YYYY-MM-DD');


        if (!this.showDateRange) {
            // Current month
            if (selectDate === 999) {
                startDate = moment().startOf('month').format('YYYY-MM-DD');
            }
            else {
                startDate = moment().subtract(selectDate, 'months').format('YYYY-MM-DD');
            }

            endDate = moment().format('YYYY-MM-DD');
        }

        this.dashboard.state = {};
        this.dashboard.state.loading = false;

        this.getOrdersConsolidated(startDate, endDate);
        //this.getInfoBillfoldState();
        this.getLastItemsBought();
        this.getResumeMasterUser();
        this.getDebtsToPayClient();

        this.SessionService.getGlobals().then(globals => {
            this.shCtrl.globals = globals;

            if (this.shCtrl.globals.currentClient.seller.movil) {
                this.sellerPhone = globals.currentClient.seller.movil;
            } else {
                this.sellerPhone = globals.currentClient.seller.telefono;
            }
        })
    
    }

    createDocumentsChart(startDate, endDate, labels, orderValues, quoteValues, billValues) {


        this.SessionService.getGlobals().then(globals => {

            let createDocumentTercero = globals.currentClient.third.name;
            let createDocumentOperatingCenter = globals.currentClient.operatingCenter.name;

            this.documentQuantitiesChart = {
                data: {
                    type: 'line',
                    "title": {
                        //   "text":"Trazabilidad Comercial - "  + createDocumentTercero
                    },
                    "subtitle": {
                        //   "text":"Comportamiento del Cliente " +
                        //   createDocumentOperatingCenter+
                        //   " desde " + startDate + "  hasta " + endDate,
                        //   "font-weight":"normal",
                        //   "x": "25%",
                    },
                    "legend": {
                        // "x": "35%",
                        // "y": "13%",
                        "layout": "horizontal",
                        // "tooltip": {
                        //     "width": "20%",
                        //     "height": "20%",
                        //     "wrap-text": true,
                        //     "padding": "5%",
                        //     "background-color": "white",
                        //     "font-color": "black",
                        //     "font-family": "Georgia",
                        //     "sticky": true,
                        //     "timeout": 10000
                        // }
                    },
                    "zoom": {
                        "background-color": "#ccccff",
                        "border-width": 5,
                        "border-color": "#3399ff",
                        "alpha": 0.3,
                        "label": { //Zooming Labels
                            "visible": true,
                            "font-color": "#3399ff",
                            "font-family": "Georgia",
                            "font-size": 10,
                            "font-style": "normal", //"italic" or "normal"
                            "font-weight": "normal", //"bold" or "normal"
                            "background-color": "white",
                            "border-width": 1,
                            "border-color": "#3399ff",
                            "alpha": 0.7,
                            "padding": "5%"
                        },
                        "active": false,
                        "preserve-zoom": true
                    },
                    "preview": {
                        "type": "area",  //"area" (default) or "line"
                        "line-color": "#33ccff",
                        "line-width": 2,
                        "line-style": "dotted",
                        "background-color": "#ffffff",
                        "preserve-zoom": false,
                        "alpha": 1,
                        "alpha-area": 0.1,
                        "margin-left": "10%",
                        "margin-right": "8%"
                    },
                    "plotarea": {
                        "margin-left": 'dynamic',
                        "margin-top": "15%",
                        "margin-right": "0%"
                        // 'margin':'dynamic'
                        // marginRight:'dynamic'
                    },
                    // "plot": {
                    //     // "short": true,
                    //     "animation": {
                    //         "effect": "2",
                    //         "speed": "300",
                    //         "method": "0",
                    //         "sequence": "1"
                    //     },     'tooltip': {
                    //     'placement': "node:top" //"node:top", "node:bottom", "node:left", "node:right", and "node:center"
                    //   },
                    //     // "value-box": {
                    //     //   "text": "$ %v",
                    //     //   "thousands-separator":",",
                    //     //   // "short":true,
                    //     //   // "short-unit":"M",
                    //     //   "font-color": "#666699",
                    //     //   "font-family": "Georgia",
                    //     //   "font-size": 10,
                    //     //   "font-weight": "normal",
                    //     //   "font-style": "normal",
                    //     //   "rules": [
                    //     //     {
                    //     //       "rule": "%v >= 0",
                    //     //     },
                    //     //     {
                    //     //       "rule": "%v <= 0",
                    //     //       "font-color": "black",
                    //     //       "font-size": 0,
                    //     //     }
                    //     //   ]
                    //     // }
                    // },
                    "scale-x": {
                        "labels": labels,
                        "zooming": true
                    },
                    "scale-y": {
                        "short": true,
                        "short-unit": "M",
                        "font-size": "9px",
                        "guide": {
                            "line-style": "dotted"
                        },
                    },
                    "crosshair-x": {
                        "plot-label": {
                            "text": "$ %v en %t",
                            "thousands-separator": ","
                        },
                        "scale-label": {
                            "text": "%t",
                        }
                    },
                    series: [
                        // {
                        //   values : quoteValues,
                        //   "text": "Cotizaciones - Total $ " + $filter('currency')(this.dashboard.quotesTotalValue, '', 0),
                        //   "description": "en Cotizaciones",
                        //   "line-color": "#f39c12",
                        //   "line-style": "solid",
                        //   "marker": {
                        //     "background-color": "#f39c12",
                        //     "size": 5
                        //   }
                        // },
                        {
                            values: orderValues,
                            "text": "Pedidos - Total $ " + this.$filter('currency')(this.dashboard.ordersTotalValue, '', 0),
                            "description": "en Pedidos",
                            "line-color": "#2759b9",
                            "line-style": "solid",
                            "marker": {
                                "background-color": "#2759b9",
                                "size": 5
                            }
                        },
                        // {
                        //   values : billValues,
                        //   "text": "Facturas - Total $ " + $filter('currency')(this.dashboard.billsTotalValue, '', 0),
                        //   "description": "en Facturas",
                        //   "line-color": "#356296",
                        //   "line-style": "solid",
                        //   "marker": {
                        //     "background-color": "#356296",
                        //     "size": 5
                        //   }
                        // }
                    ]
                }
            };
        });

        // if(!__env.adaptative){
        // this.documentQuantitiesChart.data.title.text = "Trazabilidad Comercial - "  + createDocumentTercero;
        // this.documentQuantitiesChart.data.subtitle = {
        //   "text":"Comportamiento del Cliente " +
        //   createDocumentOperatingCenter+
        //   " desde " + startDate + "  hasta " + endDate,
        //   "font-weight":"normal",
        //   "x": "25%",
        // };
        // }
    }

    getOrdersConsolidated(startDate, endDate) {

        this.SessionService.getGlobals().then(globals => {

            let thirdId = globals.currentClient.third.id;
            let branchCode = globals.currentClient.operatingCenter.code;
            let contactoId = globals.currentClient.contact.id;

            this.SalesHomeService.getOrdersConsolidated(
                thirdId,
                startDate,
                endDate,
                branchCode,
                contactoId
            )
                .then((orders) => {

                    this.dashboard.orders = orders;

                    // Orders
                    angular.forEach(orders.pedidos, (ordersQuantity, key) => {
                        if (!ordersQuantity) {
                            orders.pedidos[key] = 0;
                        }
                        if (ordersQuantity > 0) {
                            this.dashboard.ordersTotalValue += orders.pedidos[key];
                        }
                    });

                    // Quotes
                    // angular.forEach(orders.cotizaciones, function(quotesQuantity, key) {
                    //   if(!quotesQuantity) { orders.cotizaciones[key] = 0; }
                    //   if(quotesQuantity > 0) { this.dashboard.quotesTotalValue += orders.cotizaciones[key]; }
                    // });
                    //
                    // // Bills
                    // angular.forEach(orders.facturas, function(billsQuantity, key) {
                    //   if(!billsQuantity) { orders.facturas[key] = 0; }
                    //   if(billsQuantity > 0) { this.dashboard.billsTotalValue += orders.facturas[key]; }
                    // });
                    // console.log(startDate, endDate, orders.fechas, orders.pedidos, orders.cotizaciones, orders.facturas)

                    this.createDocumentsChart(startDate, endDate, orders.fechas, orders.pedidos, orders.cotizaciones, orders.facturas);

                    this.dashboard.state.loading = false;
                    this.dashboard.state.loaded = false;

                    this.dashboard.updatedAt = this.$filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');
                })
                .catch(function (error) {
                    console.log(error)
                });
        });

    }

    getLastItemsBought() {
        this.dashboard.state.loadingLastItemsBought = true;
        this.dashboard.state.loadedLastItemsBought = false;
        let userId = '';
        try {
            userId = this.shCtrl.globals.currentUser.userId;
        }
        catch (e) {
        }

        this.$timeout(() => {
            this.SalesHomeService.getLastItemsBought(userId)
                .then((response) => {
                    this.lastItemsBought = response;
                    this.dashboard.state.loadingLastItemsBought = false;
                    this.dashboard.state.loadedLastItemsBought = true;
                })
                .catch((error) => {
                    this.dashboard.state.loadingLastItemsBought = false;
                    this.dashboard.state.loadedLastItemsBought = true;
                });
        }, 2000);
    }

    getInfoBillfoldState() {
        this.dashboard.state.loadingBillfoldResume = true;
        this.dashboard.state.loadedBillfoldResume = true;

        this.SessionService.getGlobals().then(globals => {

            let thirdDocumentNumber = globals.currentClient.third.documentNumber;
            //let branchCode = globals.currentClient.operatingCenter.code;

            this.zoneService.getBriefcase(
                thirdDocumentNumber).then((billfoldResume) => {

                    console.log(billfoldResume);

                    this.dashboard.billfoldResume = billfoldResume;

                    this.dashboard.state.loadingBillfoldResume = false;
                    this.dashboard.state.loadedBillfoldResume = true;
                }).catch((error) => {
                    this.dashboard.state.loadingBillfoldResume = false;
                    this.dashboard.state.loadedBillfoldResume = true;
                });

        });

    }

    getResumeMasterUser() {

        this.dashboard.state.loadingResumeMasterUser = true;
        this.dashboard.state.loadedResumeMasterUser = false;

        this.SessionService.getGlobals().then(globals => {
            let userId = globals.currentUser.userId;

            this.SalesHomeService.getResumeMasterUser(userId).then((response) => {

                this.dashboard.userMasterResume = response.data;
                this.dashboard.state.loadingResumeMasterUser = false;
                this.dashboard.state.loadedResumeMasterUser = true;

            }).catch((error) => {

                this.dashboard.state.loadingResumeMasterUser = false;
                this.dashboard.state.loadedResumeMasterUser = true;

            });
        });


    }

    openMap(branch) {
        let options = {
            center: {
                latitude: branch.latitude,
                longitude: branch.longitude
            },
            zoom: 15,
            pan: true
        };
        let modal_options = this.$uibModal.open({
            animation: true,
            template: modalMap,
            controller: 'ModalMapController',
            controllerAs: 'mdCtrl',
            size: '',
            resolve: {
                modalOptions: () => options
            }
        });
        modal_options.result.then(() => {

        }).catch(reason => {

        });
    }

    messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalConfirmation,
            controller: 'ModalResponseController',
            controllerAs: 'mdCtrl',
            size: options.size,
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(() => {
            if (callAcept) {
                callback();
            }
        }).catch(reason => {
            if (callCancel) {
                callbackCancel();
            }
        });
    }

    decreaseProductQuantity(product) {
        if (product.quantityCart > 1){
            product.quantityCart-= (product.factor_pedido>0)?product.factor_pedido:1;
        }
        if(product.cantidad_minima>0 && product.quantityCart < product.cantidad_minima){
            if(product.factor_pedido > product.cantidad_minima){
                product.quantityCart=product.factor_pedido;
            }else{
                product.quantityCart=product.cantidad_minima;
            }
        }else if(product.cantidad_minima<0 && product.quantityCart < product.cantidad_minima){
            product.quantityCart=1;
        }
    }

    increaseProductQuantity(product) {
        product.quantityCart = parseFloat(product.quantityCart) + ((parseFloat(product.factor_pedido)>0)? parseFloat(product.factor_pedido):1);
    }

    updateFavoriteProducts(product) {
        product.isSettingAsFavorite = true;
        let userId = '';
        try {
            userId = this.shCtrl.globals.currentUser.userId;
        } catch (e) {
        }
        if (userId) {
            let data = {
                'productId': product.id,
                'userId': userId,
                'setFavorite': !product.isFavorite
            };

            this.SalesHomeService.updateFavoriteProducts(data).then(response => {

                if (!response.error) {
                    this.SalesHomeService.getResumeProductsFavorites(this.shCtrl.globals.currentUser.userId).then(favoritesResponse => {
                        this.shCtrl.globals.currentUser.favoriteItems = favoritesResponse;
                        this.SessionService.put('globals', this.shCtrl.globals);

                    });
                }

                product.isFavorite = !product.isFavorite;
                product.isSettingAsFavorite = false;


            }).catch(error => {
                product.isSettingAsFavorite = false;
                let options = {
                    title: '',
                    isHtml: false,
                    content: 'Ha ocurrido un error al actualizar el producto',
                    size: '',
                    showBottonCancel: false,
                    textActionCancel: '',
                    textAction: 'Aceptar'
                };
                this.messageResponse(options);
            });
        }
    }


    addItemToCart(product) {
        if (product.id) {
            let userId = '',
                cart = null;
            try {
                userId = this.shCtrl.globals.currentUser.userId;
            } catch (e) {
            }
            try {
                cart = this.shCtrl.cart;
            } catch (e) {
            }


            let validation = this.SessionService.validateFactorItems(product.quantityCart, product);

            if (validation.error) {

                let options = {
                    title: '',
                    isHtml: true,
                    content: validation.message,
                    size: '',
                    showBottonCancel: false,
                    textActionCancel: '',
                    textAction: 'Aceptar'
                };
                this.messageResponse(options);
                return;
            }


            this.CartService.addItemToCart(product, product.quantityCart, null, null, userId, cart).then(response => {
                if (!response.error) {
                    // this.$scope.$emit('onUpdateCart');

                    // let modalInstance = this.$uibModal.open({
                    //   animation: true,
                    //   template: modalConfirmationCart,
                    //   controller: 'ModalConfirmationController',
                    //   controllerAs: 'mdCtrl',
                    //   size: 'lg',
                    //   resolve: {
                    //     product: () => product
                    //   }
                    // });

                    this.dataCart = {};
                    this.dataProducs = {};

                    if (!response.pesoValidoBodega && response.modalidadParametrizada) {
                        this.cambiarSucursalVolumenItemMostrarMedioEnvio(response,product, product.quantityCart);
                    } else if (!response.pesoValidoBodega && !response.modalidadParametrizada) {
                        this.cambiarSucursalVolumenItems(response, cart, product, product.quantityCart);
                    } else if (response.pesoValidoBodega && response.modalidadParametrizada) { // Si el peso de la bodega es valido y la modalidad no esta en el carrito
                        this.showModalSelectModalidadPago(response, product, product.quantityCart);
                    } else {
                        this.modalConfirmation(product, product.quantityCart);
                    }

                } else {
                    /* if (response.agotado) {
                         product.cantidad = response.itemStock;
                         this.CartService.updateItemsNotAvailable(product, product.quantityCart, userId);
                     }*/


                    let options = {
                        title: '',
                        isHtml: true,
                        content: response.message,
                        size: '',
                        showBottonCancel: false,
                        textActionCancel: '',
                        textAction: 'Aceptar'
                    };
                    this.messageResponse(options);
                }
            }).catch(reason => {
                let options = {
                    title: '',
                    isHtml: false,
                    content: reason,
                    size: '',
                    showBottonCancel: false,
                    textActionCancel: '',
                    textAction: 'Aceptar'
                };
                this.messageResponse(options);
            })
        }
    }

    modalConfirmation(products, quantity) {

        this.productAdded = products;
        this.productAdded.image = products.imagesDetail[0].path + products.imagesDetail[0].image;
        this.productAdded.price = products.itemPrice;
        this.productAdded.discount = products.discountValue;
        this.productAdded.ivaValue = products.taxValue;
        this.productAdded.quantity = quantity;
        //this.productAdded.total = (products.itemPrice - products.discountValue + products.taxValue) * quantity;
        this.productAdded.total = (products.itemPrice - products.discountValue + products.taxValue + products.taxImpConsumoValue) * quantity;


        if (__env.adaptative) {
            this.messageMaterial(products.name + ' Ha sido agregado correctamente')
        } else {
            $('#ModalproductDetail').modal('toggle');
        }

        this.$scope.$emit('onUpdateCart', 'modalResponseItems');
    }

    messageMaterial(text) {
        var mdToast = this.$mdToast;
        this.$mdToast.show({
            hideDelay: 7000,
            controller: function () {
                this.closeToast = function () {
                    mdToast.hide();
                }

            },
            controllerAs: 'toast',
            template: '<md-toast>\n' +
                '  <span class="md-toast-text">' + text + '</span>\n' +
                '  <md-button ng-click="toast.closeToast()">\n' +
                '    Cerrar\n' +
                '  </md-button>\n' +
                '</md-toast>'
        });
    }

    showModalSelectModalidadPago(modalidadesPago, product, quantity) {

        let options = {
            userData: this.shCtrl.globals,
            branches: this.shCtrl.globals.currentUser.operatingCenters,
            currentBranch: this.shCtrl.globals.currentClient.operatingCenter,
            cmsMessage: this.shCtrl.globalParams.cmsInfo,
            modalidadesPago: modalidadesPago
        };
        let modalInstance = this.$uibModal.open({
            animation: true,
            static: true,
            template: modalSelectModalidadPago,
            controller: 'ModalSelectModalidadController',
            controllerAs: 'mdCtrl',
            backdrop: 'static',
            keyboard: false,
            size: 'lg',
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(result => {
            this.modalConfirmation(product, quantity);
        }).catch(reason => {

        });
    }

    cambiarSucursalVolumenItems(response, cart, product, quantity) {
        let cartId = cart.cartId
        let responseData = response
        this.CartService.getShippingMode(cartId).then(response => {
            if (response.modalidad) {
                this.setSucursalesPorModalidad(response, cartId, product, quantity);
            } else {
                this.obtenerSucursalSecundaria(cartId, product, quantity);
            }
        });
    }

    setSucursalesPorModalidad(response, cartId, product, quantity) {
        let idCiudad = this.shCtrl.globals.currentClient.operatingCenter.ciudad_id;
        let idUsuario = this.shCtrl.globals.currentUser.userId;
        let currentClient  = this.SessionService.get('currentClient');
        let idSucursalActual = currentClient.operatingCenter.id;
        let data = {
            'userId': idUsuario,
            'ciudadId': idCiudad
        };
        let tipoModalidad = response.modalidad.tipo_modalidad;
        // Si la modalidad es recoge 
        if (tipoModalidad == 0) {
            this.CartService.getSecondaryBranch(data).then(response => {
                let idSucursalSecundaria = response.listaSucursales[0].id;
                if (idSucursalSecundaria != null) {
                    if(idSucursalSecundaria != idSucursalActual){
                        this.setSucursalSecundariaRecogeEntrega(idSucursalSecundaria, idUsuario, product, quantity);
                    }else{
                        this.modalConfirmation(product, quantity);
                    }
                }
            });
            this.CartService.updateDateCart(cartId).then(response => {
                return response;
            });
            // Si es a domicilio 
        } else {
            this.CartService.getSecondaryBranch(data).then(response => {
                let idSucursalSecundaria = response.listaSucursales[0].id;
                let idCiudad = response.listaSucursales[0].ciudad_id;

                if (idCiudad != null && idSucursalSecundaria != null && cartId != null) {
                    this.CartService.updatePromiseCart(cartId, idSucursalSecundaria, idCiudad).then(response => {
                        let aplicaServicioDescargue = response.aplicaServicioDescargue;
                        if (idSucursalSecundaria != null) {
                            if(idSucursalSecundaria != idSucursalActual){
                                this.setSucursalSecundariaTipoDomicilio(idSucursalSecundaria, idUsuario, aplicaServicioDescargue, product, quantity);
                            }else{
                                this.modalConfirmation(product, quantity);
                            }
                        }
                    });
                }
            });
        }
    }

    setSucursalSecundariaRecogeEntrega(idSucursal, userId, product, quantity) {

        let mensajeCambioSucursal = '';
        let mensajeCambioHorarioBodega = '';
        let allMessage = [];
        try {
            mensajeCambioSucursal = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_SUCURSAL;
            mensajeCambioHorarioBodega = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_HORARIO_BODEGA;
            allMessage.push(mensajeCambioSucursal);
            allMessage.push(mensajeCambioHorarioBodega);

        } catch (e) {
        }
        this.SharedService.setOperatingCenter({ 'userId': userId, 'operatingCenterId': idSucursal, 'origen': 'b2b' }).then(response => {
            if (!response.error) {
                // Set the current client
                try {
                    let newCurrentClient = JSON.parse(global.localStorage.currentClient);
                    newCurrentClient.operatingCenter = response.branch;
                    newCurrentClient.seller = response.seller;
                    this.SessionService.put('currentClient', newCurrentClient);
                    this.SessionService.put('cartId', response.cartID);
                    this.shCtrl.userData.globals.currentClient.operatingCenter = response.branch;
                    this.shCtrl.userData.globals.currentClient.seller = response.seller;

                    this.$rootScope.$broadcast('actualizarHeader', response.branch);
                    this.SharedService.assignWarehouseBasketCode({ 'cartId': this.shCtrl.cart.cartId }).then(response => {
                        if (!response.error) {
                          if (allMessage !== null) {
                            this.showModalAllMessage(allMessage, product, quantity);
                          }
                        }
                    });
                } catch (e) {
                }
            } else {
                console.log('Ocurrio un erro al cambiar la sucursal')
            }
        }).catch(reason => {
            this.state.saving = false;
            this.state.error = true;
        });
    }

    setSucursalSecundariaTipoDomicilio(idSucursal, userId, aplicaServicioDescargue, product, quantity) {

        let mensajeCambioSucursal = '';
        let mensajeDestinoNoDisponilble = '';
        let mensajeCambioPromesa = '';
        let allMessage = [];

        try {
            mensajeCambioSucursal = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_SUCURSAL;
            mensajeCambioPromesa = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_PROMESA;
            allMessage.push(mensajeCambioSucursal);
            allMessage.push(mensajeCambioPromesa);

            if (!aplicaServicioDescargue) {
                mensajeDestinoNoDisponilble = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_INFORMATITVO_DESTINOS_NO_DISPONIBLES;
                allMessage.push(mensajeDestinoNoDisponilble);
            }

        } catch (e) {
        }
        this.SharedService.setOperatingCenter({ 'userId': userId, 'operatingCenterId': idSucursal, 'origen': 'b2b' }).then(response => {
            if (!response.error) {
                // Set the current client
                try {
                    let newCurrentClient = JSON.parse(global.localStorage.currentClient);
                    newCurrentClient.operatingCenter = response.branch;
                    newCurrentClient.seller = response.seller;
                    this.SessionService.put('currentClient', newCurrentClient);
                    this.SessionService.put('cartId', response.cartID);
                    this.shCtrl.userData.globals.currentClient.operatingCenter = response.branch;
                    this.shCtrl.userData.globals.currentClient.seller = response.seller;

                    this.$rootScope.$broadcast('actualizarHeader', response.branch);
                    this.SharedService.assignWarehouseBasketCode({ 'cartId': this.shCtrl.cart.cartId }).then(response => {
                        if (!response.error) {
                          if (allMessage !== null) {
                            this.showModalAllMessage(allMessage, product, quantity);
                          }
                        }
                    });
                } catch (e) {
                }
            } else {
                console.log('ocurrio un error al cambiar de sucursal')
            }
        }).catch(reason => {
            this.state.saving = false;
            this.state.error = true;
        });
    }

    cambiarSucursalVolumenItemMostrarMedioEnvio(response, product, quantity) {
        let responseData = response
        let idCiudad = this.shCtrl.globals.currentClient.operatingCenter.ciudad_id;
        let idUsuario = this.shCtrl.globals.currentUser.userId;
        let currentClient  = this.SessionService.get('currentClient');
        let idSucursalActual = currentClient.operatingCenter.id;
        let data = {
            'userId': idUsuario,
            'ciudadId': idCiudad
        };
        this.CartService.getSecondaryBranch(data).then(response => {
            let idSucursalSecundaria = response.listaSucursales[0].id;
            if (idSucursalSecundaria != null) {
                if(idSucursalSecundaria != idSucursalActual){
                    this.setSucursalSecundariaMostrarModalMedioEnvio(idSucursalSecundaria, idUsuario, responseData, product, quantity);
                }else{
                    this.modalConfirmation(product, quantity);
                }
            }
        });


    }

    setSucursalSecundariaMostrarModalMedioEnvio(idSucursal, userId, mediosEnvio, product, quantity) {
        let mensajeCambioSucursal = '';
        try {
            mensajeCambioSucursal = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_SUCURSAL;
        } catch (e) {
        }
        this.SharedService.setOperatingCenter({ 'userId': userId, 'operatingCenterId': idSucursal, 'origen': 'b2b' }).then(response => {
            if (!response.error) {
                // Set the current client
                try {
                    let newCurrentClient = JSON.parse(global.localStorage.currentClient);
                    newCurrentClient.operatingCenter = response.branch;
                    newCurrentClient.seller = response.seller;
                    this.SessionService.put('currentClient', newCurrentClient);
                    this.SessionService.put('cartId', response.cartID);
                    this.shCtrl.userData.globals.currentClient.operatingCenter = response.branch;
                    this.shCtrl.userData.globals.currentClient.seller = response.seller;
                    this.$rootScope.$broadcast('actualizarHeader', response.branch);
                    this.SharedService.assignWarehouseBasketCode({ 'cartId': this.shCtrl.cart.cartId}).then(response =>{
                        if (!response.error) {
                          if (mensajeCambioSucursal !== '') {
                            let optionsMessage = {
                              title: 'Actualización de precios',
                              isHtml: true,
                              content: mensajeCambioSucursal,
                              size: '',
                              showBottonCancel: false,
                              textActionCancel: '',
                              textAction: 'Aceptar'
                            };
                            let modalInstance = this.$uibModal.open({
                              animation: true,
                              template: modalConfirmation,
                              controller: 'ModalResponseController',
                              controllerAs: 'mdCtrl',
                              backdrop: 'static',
                              size: 'md',
                              resolve: {
                                modalOptions: () => optionsMessage
                              }
                            });
                            modalInstance.result.then(() => {
                              this.showModalSelectModalidadPago(mediosEnvio, product, quantity);
                            }).catch(() => {
            
                            });
                          }
                        }
                      });
                } catch (e) {
                }
            } else {
                alert('Ocurrion un error al mostrar los medios de envio')
            }
        }).catch(reason => {
            this.state.saving = false;
            this.state.error = true;
        });
    }

    showModalAllMessage(allMesagge, product, quantity) {
        let contentDynamic = 'Se realizaron las siguientes modificaciones: </br>';

        for (let i = 0; i < allMesagge.length; i++) {
            contentDynamic += `
                                <ul><li>` + allMesagge[i] + `</li></ul>`;
        }

        if (contentDynamic != '') {
            let optionsMessage = {
                title: 'Actualización de precios',
                isHtml: true,
                content: contentDynamic,
                size: '',
                showBottonCancel: false,
                textActionCancel: '',
                textAction: 'Aceptar',
                backdrop: 'static'
            };

            let modalInstance = this.$uibModal.open({
                animation: true,
                template: modalConfirmation,
                controller: 'ModalResponseController',
                controllerAs: 'mdCtrl',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    modalOptions: () => optionsMessage
                }
            });
            modalInstance.result.then(() => {
                this.modalConfirmation(product, quantity);
            }).catch(() => {

            });
        }
    }

    obtenerSucursalSecundaria(cartId, product, quantity) {
        let idCiudad = this.shCtrl.globals.currentClient.operatingCenter.ciudad_id;
        let idUsuario = this.shCtrl.globals.currentUser.userId;
        let currentClient  = this.SessionService.get('currentClient');
        let idSucursalActual = currentClient.operatingCenter.id;
        let data = {
          'userId': idUsuario,
          'ciudadId': idCiudad
        };
        // Si la modalidad es recoge 
        if (data != null) {
          this.CartService.getSecondaryBranch(data).then(response => {
            let idSucursalSecundaria = response.listaSucursales[0].id;
            if (idSucursalSecundaria != null) {
                if(idSucursalSecundaria != idSucursalActual){
                    this.setSucursalSecundariaSinModalidad(idSucursalSecundaria, idUsuario, product, quantity);
                }else{
                    this.modalConfirmation(product, quantity);
                }
            }
          });
          this.CartService.updateDateCart(cartId).then(response => {
            return response;
          });
        }
      }
    
      setSucursalSecundariaSinModalidad(idSucursal, userId, product, quantity) {
    
        let mensajeCambioSucursal = '';
        let allMessage = [];
        try {
          mensajeCambioSucursal = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_SUCURSAL;
          allMessage.push(mensajeCambioSucursal);
        } catch (e) {
        }
        this.SharedService.setOperatingCenter({ 'userId': userId, 'operatingCenterId': idSucursal, 'origen': 'b2b' }).then(response => {
          if (!response.error) {
            // Set the current client
            try {
              let newCurrentClient = JSON.parse(global.localStorage.currentClient);
              newCurrentClient.operatingCenter = response.branch;
              newCurrentClient.seller = response.seller;
              this.SessionService.put('currentClient', newCurrentClient);
              this.SessionService.put('cartId', response.cartID);
              this.shCtrl.userData.globals.currentClient.operatingCenter = response.branch;
              this.shCtrl.userData.globals.currentClient.seller = response.seller;
    
              this.$rootScope.$broadcast('actualizarHeader', response.branch);
              this.SharedService.assignWarehouseBasketCode({ 'cartId': this.shCtrl.cart.cartId }).then(response => {
                if (!response.error) {
                  if (allMessage !== null) {
                    this.showModalAllMessage(allMessage, product, quantity);
                  }
                }
              });
            } catch (e) {
            }
          } else {
            console.log('Ocurrio un erro al cambiar la sucursal')
          }
        }).catch(reason => {
          this.state.saving = false;
          this.state.error = true;
        });
      }

    getDebtsToPayClient() {
        this.dashboard.state.loadingBillfoldResume = true;
        this.dashboard.state.loadedBillfoldResume = true;

        try {

            // let documentNumber=this.shCtrl.globals.currentClient.third.documentNumber;
            let data = {
                idCia: 1,
                nit: this.shCtrl.globals.currentClient.third.documentNumber,
                idSucursal: this.shCtrl.globals.currentClient.operatingCenter.code,
                moneda: 'COP'
              };
            // let codeSucursal = this.shCtrl.globals.currentClient.operatingCenter.code;
          
            // this.billfoldService.getBillFoldsByClient(documentNumber,codeSucursal)
            // .then(billfolds => {

            //     if(billfolds === 'null'){
            //         this.debtsToPayResumen = [];
            //     }else{
            //         this.debtsToPayResumen = billfolds.data.adicional;
            //     }

            //     this.dashboard.state.loadingBillfoldResume = false;
            //     this.dashboard.state.loadedBillfoldResume = true;
            // })
            // .catch(error => {
            //     this.dashboard.state.loadingBillfoldResume = false;
            //     this.dashboard.state.loadedBillfoldResume = true;
            //     console.log(error);
            // });

            /**
             * @autor Juan David Chica
             * @comentario se comenta el consumo del la api consulta_analisis_cliente para realizar el consumo de la api de AGR
             */
            
            this.CartService.getDebtsToPay(data).then(billfoldResume => {
                this.debtsToPayResumen = billfoldResume.data;
                this.dataComandResumen = billfoldResume.dataAdicional.sistemaConcretos;
                this.lastUpdatedBillResume = this.$filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');

                this.dashboard.state.loadingBillfoldResume = false;
                this.dashboard.state.loadedBillfoldResume = true;
            })
            .catch(error => {
                this.dashboard.state.loadingBillfoldResume = false;
                this.dashboard.state.loadedBillfoldResume = true;
                console.log(error);
            });

        }
        catch (e) {
            console.log(e);
        }
    }
}

SalesHomeController.$inject = inject;

export default SalesHomeController;




/** WEBPACK FOOTER **
 ** ./www/components/sales-home/sales-home.controller.js
 **/